import { FbSDK } from 'constants/GraphApiRoutes';
import { Logger } from 'infra/adapters';

export class Facebook {
  static getScript() {
    return new Promise(resolve => {
      if (window.FB) {
        resolve(window.FB);
      }

      const id = 'facebook-jssdk';
      const fjs = document.querySelectorAll('script')[0];
      if (document.getElementById(id)) {
        return;
      }

      const js = document.createElement('script');
      js.id = id;
      js.src = FbSDK;

      js.addEventListener('load', () => {
        Object.assign(this, {
          AppEvents: window.FB.AppEvents,
          Canvas: window.FB.Canvas,
          Event: window.FB.Event,
          Frictionless: window.FB.Frictionless,
          XFBML: window.FB.XFBML,
        });

        resolve(window.FB);
      });

      fjs.parentNode.insertBefore(js, fjs);
    });
  }

  static init(params = {}) {
    return new Promise(async resolve => {
      const FB = await this.getScript();
      FB.init(params);
      FB.AppEvents.logPageView();

      resolve(FB);
    });
  }

  static api(...params) {
    return new Promise(async resolve => {
      const FB = await this.getScript();

      const callback = response => {
        Logger.Debug(`facebook api method returned with callback: ${response}`);
        resolve(response);
      };

      if (params.length > 3) {
        params = params.slice(0, 3);
      }

      params.push(callback);
      FB.api(...params);
    });
  }

  static ui(params) {
    return new Promise(async resolve => {
      const FB = await this.getScript();

      FB.ui(params, response => {
        resolve(response);
      });
    });
  }

  static getLoginStatus() {
    return new Promise(async resolve => {
      const FB = await this.getScript();

      FB.getLoginStatus(response => {
        resolve(response);
      });
    });
  }

  static login(responseCallback, params) {
    return new Promise(async resolve => {
      const FB = await this.getScript();

      FB.login(responseCallback, params);
      Logger.Debug(`facebook login method returned with callback: ${responseCallback}`);
    });
  }

  static logout() {
    return new Promise(async resolve => {
      const FB = await this.getScript();

      FB.logout(response => {
        Logger.Debug(`facebook logout method returned with response: ${response}`);
        resolve(response);
      });
    });
  }

  static getAuthResponse() {
    return new Promise(async resolve => {
      const FB = await this.getScript();

      resolve(FB.getAuthResponse());
    });
  }

  static me() {
    return new Promise(async resolve => {
      const me = await this.api('/me?fields=name,email,gender,verified,link');

      resolve(me);
    });
  }
}
